import VacancyInterface from './Vacancy';

interface VN extends VacancyInterface {
  [key:string]: any;
}

function normalizeVacancy(obj: any): VN {
  const normalizedVacancy: VN = {
    id: '',
    name: '',
    uri_alias: '',
    area: '',
    has_team_success_tab: false,
    departament: '',
    is_referal: false,
    is_referal_bridge: false,
    cities: [],
    main_tabs: [],
    tabs: []
  };
  return Object.keys(obj).reduce((akk, key) => {
    if (obj[key] && typeof obj[key] === 'object' && "id" in obj[key] && "name" in obj[key]) {
      akk[key] = obj[key].name
    } else if (obj[key] && typeof obj[key] === 'object' && "id" in obj[key]) {
      akk[key] = obj[key].id
    } else {
      akk[key] = obj[key];
    }
    return akk;
  }, normalizedVacancy);
}

export default normalizeVacancy;
